(() => {
  const controllers = new WeakMap();

  const initialize = (root) => {
    if (!root || controllers.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    controllers.set(root, controller);

    root.querySelectorAll('[data-needs-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = root.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
        if (!panel) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
        button.firstChild.textContent = `${expanded ? button.dataset.openLabel : button.dataset.closeLabel} `;
        const icon = button.querySelector('span');
        if (icon) icon.textContent = expanded ? '↓' : '↑';
      }, { signal });
    });

    const tabs = [...root.querySelectorAll('[data-featured-tab]')];
    tabs.forEach((tab, index) => {
      const activate = () => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = root.querySelector(`#${CSS.escape(item.getAttribute('aria-controls'))}`);
          if (panel) panel.hidden = !selected;
        });
        const panel = root.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        panel?.querySelector('[data-carousel-track]')?.scrollTo({ left: 0, behavior: 'auto' });
      };
      tab.addEventListener('click', activate, { signal });
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        tabs[next].focus();
        tabs[next].click();
      }, { signal });
    });

    root.querySelectorAll('[data-carousel-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = button.closest('[data-featured-panel]');
        const track = panel?.querySelector('[data-carousel-track]');
        if (!track) return;
        const direction = button.dataset.carouselButton === 'next' ? 1 : -1;
        track.classList.remove('carousel-motion-next', 'carousel-motion-previous');
        void track.offsetWidth;
        track.classList.add(direction > 0 ? 'carousel-motion-next' : 'carousel-motion-previous');
        track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
        window.setTimeout(() => track.classList.remove('carousel-motion-next', 'carousel-motion-previous'), 520);
      }, { signal });
    });

    root.querySelectorAll('[data-faq-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.faq-item');
        const expanded = button.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-faq-button]').forEach((other) => {
          other.setAttribute('aria-expanded', 'false');
          other.closest('.faq-item')?.classList.remove('open');
          const mark = other.querySelector('b');
          if (mark) mark.textContent = '+';
        });
        if (!expanded) {
          button.setAttribute('aria-expanded', 'true');
          item?.classList.add('open');
          const mark = button.querySelector('b');
          if (mark) mark.textContent = '−';
        }
      }, { signal });
    });
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-home-starside-section]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-home-starside-section]').forEach((root) => {
      controllers.get(root)?.abort();
      controllers.delete(root);
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const tab = event.target.closest('[data-featured-tab]');
    if (tab) tab.click();
  });
})();
